import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {
    countMessageSent: (idMessage, params) =>
      `${baseURL}/api/message/${idMessage}/count/sent?${encodeParams(params)}`,
    countMessageDeliveries: (idMessage, params) =>
      `${baseURL}/api/message/${idMessage}/count/deliveries?${encodeParams(
        params
      )}`,
    countMessageClicks: (idMessage, params) =>
      `${baseURL}/api/message/${idMessage}/count/clicks?${encodeParams(params)}`
  }
})(process.env.BESMSSERVICES_URL)

/**
 *
 * @param {number} idMessage
 * @param {Object} params
 * @param {number} params.idRecipient
 * @returns
 */
export const beSmsServicesCountMessageSent = (idMessage, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.countMessageSent(idMessage, params)
  }).then(extractApiData)
}

/**
 *
 * @param {number} idMessage
 * @param {Object} params
 * @param {number} params.idRecipient
 * @returns
 */
export const beSmsServicesCountMessageDeliveries = (idMessage, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.countMessageDeliveries(idMessage, params)
  }).then(extractApiData)
}

/**
 *
 * @param {number} idMessage
 * @param {Object} params
 * @param {number} params.idRecipient
 * @returns
 */
export const beSmsServicesCountMessageClicks = (idMessage, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.countMessageClicks(idMessage, params)
  }).then(extractApiData)
}
